var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "top"
    }
  }, [_c('portal', {
    attrs: {
      "to": "top-bar-right"
    }
  }, [_c('YButton', {
    attrs: {
      "color": "blue"
    },
    on: {
      "click": _vm.openCreateModal
    }
  }, [_vm._v("Create Rules")])], 1), _c('div', [_c('RulesTableWrapper')], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }